import React, { useEffect, useState } from 'react';

const Legenda = ( { objLegenda } ) => {

  return (
    <div className='d-flex flex-column gap-2'>
      <span style={{fontSize: '12px'}} className=''>Legenda:</span>
      {Object.keys(objLegenda).map((key, index) => {
        return (
          <div key={index} className='d-flex align-items-center'>
            <span style={{fontSize: '12px'}}>
              {key}
            </span>
            <div
              className='ml-1'
              style={{
                backgroundColor: objLegenda[key],
                width: '12px',
                height: '12px',
                borderRadius: '50%'
              }}
            >
            </div>
          </div>
        )
      })}
    </div>
  );
};

export default Legenda;
